// extracted by mini-css-extract-plugin
export default {"UnorderedList":"UnorderedList_UnorderedList__3U00G"};